<script type="text/javascript">
	import moment from "moment";

	import MenuItem from "../UI/FlyoutMenu/MenuItem.svelte";
	import Icon from "../UI/Icons/Icon";

	import Datepicker from "svelte-calendar";
	import Radio from '@smui/radio';
	import FormField from '@smui/form-field';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import HelperText from "@smui/textfield/helper-text/index";
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Button, {Label} from '@smui/button';
	import Card from '@smui/card';
	import TextfieldWithButton from "../UI/TextfieldWithButton/TextfieldWithButton.svelte";

	import '../UI/LayerList/LayerList.scss';
	import LayerListSwitch from '../UI/LayerList/LayerListSwitch.svelte';

	// import testresults from "./testresult.json"
	import WeatherDataSource from "./WeatherDataSource"
	import EnvironmentGraph from "./EnvironmentGraph.svelte"
	import GraphProperty from "./GraphProperty";
	import GraphPropertyUnitType from "./GraphPropertyUnitType";

	import { onMount, onDestroy } from "svelte";
	import { get, writable } from "svelte/store";

	import MapStore from "../Map/Store";
	import MapLayerManager from "../Map/MapLayerManager";
	import MapDataSource from "../Map/Enums/MapDataSource";
	import WeatherStore from "./Store";
	import InfoCardStore from "../UI/InfoCard/Store";

	import TimeSlider from "../UI/TimeSlider/TimeSlider.svelte";
	import DirectionalArrow from "../UI/DirectionalArrow.svelte";

	import DownloadButton from "../UI/DownloadButton/DownloadButton.svelte";
	import DownloadHelper from "../Helpers/DownloadHelper";
	import DataFormat from "../Enums/DataFormat";

	import IdentityHelper from "../Branding/IdentityHelper";
	import User from "../Branding/User";
	import Feature from "../Branding/Feature";

	import GeoHelper from "../Helpers/GeoHelper";
	import StringHelper from "../Helpers/StringHelper";
	import FilterHelper from "../Helpers/FilterHelper";
	import roundFloat from "../Helpers/Misc/roundFloat";

	import LoadState from "../Enums/LoadState";
	import DateDialect from "../Enums/DateDialect";
	import LoadingStore from "../LoadingStore";

	import Router from "../Router";

	import DownsampleRate from "../Enums/DownsampleRate";
	import "./Weather.scss";
	import WeatherTableRow from "./WeatherTableRow.svelte";

	import AuthStore from "../Auth/Store";
	import AuthState from "../Auth/Enums/AuthState";

	import { getOneYearAgo, getTwoYearsAgo } from "../Helpers/Misc/timeHelper";
import ModelType from "../Models/ModelType";
import MenuItemTitle from "../UI/FlyoutMenu/MenuItemTitle.svelte";
import Vessel from "../Models/Vessel";

	let useYearsAgo = getOneYearAgo();
	let authState = AuthStore.meta.state;
	$: {
		if ($authState === AuthState.LOGGED_IN) {
			if (User.hasFeature(Feature.ENVIRONMENT.HISTORY.TWO_YEARS)) {
				useYearsAgo = getTwoYearsAgo();
			}
		}
	}

	let state = WeatherStore.meta.loadState;
	let error = WeatherStore.meta.error;
	let lastUpdated = WeatherStore.meta.lastUpdated;

	let vessel = WeatherStore.query.useVessel;

	let fromFormattedSelected, toFormattedSelected;
	let fromDatetime = WeatherStore.query.fromDatetime;
	let fromDatetimeReadable;
	let toDatetime = WeatherStore.query.toDatetime;
	let toDatetimeReadable;
	$: {
		fromDatetimeReadable = moment($fromDatetime).format("YYYY/MM/DD HH:mm a");
		toDatetimeReadable = moment($toDatetime).format("YYYY/MM/DD HH:mm a");
	}

	let lngLat = WeatherStore.query.lngLat;
	let lngLatReadable = WeatherStore.query.lngLatReadable;
	let lngLatMarker = WeatherStore.query.lngLatMarker;
	let showAltitudes = [1000, 800, 500, 200];
	$: {
		if ($vessel !== null) {
			$lngLatReadable = roundFloat($lngLat.lng, 2) + ", " + roundFloat($lngLat.lat, 2);

			$fromDatetime = moment($vessel.currentTimestamp).startOf("day").toDate();
			$toDatetime = moment($vessel.currentTimestamp).add(1, "day").toDate();

			if ($vessel.type === ModelType.AIRCRAFT) {
				let hpa = GeoHelper.feetToMbar($vessel.currentValidAltitude);
				if (hpa < 200) {
					showAltitudes = [200];
				}
				else if (hpa >= 200 && hpa < 500) {
					showAltitudes = [200, 500];
				}
				else if (hpa >= 500 && hpa < 800) {
					showAltitudes = [500, 800];
				}
				else if (hpa >= 800) {
					showAltitudes = [800, 1000];
				}
				else if (hpa >= 1000) {
					showAltitudes = [1000];
				}
			}

		}
	}
	
	onMount(() => {
		WeatherStore.actions.initMap();
		$lastUpdated = Date.now();
	});

	onDestroy(()=>{
		WeatherStore.actions.deinitMap();
	});

	let datetimeFormat = "MMMM Do YYYY, hh:mm:ssa [(UTC)]";

	let updatePointEvent = (e) => {
		updatePoint(e.target.value);
	};
	let updatePoint = (value) => {
		$lngLatReadable = value;
		const parsedLngLat = GeoHelper.parseStringLngLat($lngLatReadable);
		//console.log("updatePoint", lngLatReadable, parsedLngLat, e);
		$lngLat.lng = parsedLngLat[0];
		$lngLat.lat = parsedLngLat[1];
		WeatherStore.query.lngLatMarkerPopup.setHTML("<b>(" + $lngLat.lng + ", " + $lngLat.lat + ")</b>");
		lngLatMarker.setLngLat([$lngLat.lng, $lngLat.lat]);
		lngLatMarker.setPopup(WeatherStore.query.lngLatMarkerPopup);
		lngLatMarker.addTo(MapStore.helpers.getMap());



		//WeatherStore.actions.compute();
	}




	let current = WeatherStore.resultCurrent.weather;
	let results = WeatherStore.results.weather;
	let elevation = WeatherStore.results.elevation;
	let tidalExtremes = WeatherStore.results.tidalExtremes;
	let astronomyCurrent = WeatherStore.resultCurrent.astronomy;
	let tidalExtremeCurrent = WeatherStore.resultCurrent.tidalExtremes;

	let tideStationMarker = WeatherStore.results.tideStationMarker;
	let updateTideStationMarker = () => {
		if ($tidalExtremes && $tidalExtremes.meta) {
			let text = "<b>(" + $tidalExtremes.meta.station.lng + ", " + $tidalExtremes.meta.station.lat + ")</b><br/>" + $tidalExtremes.meta.station.name.toUpperCase();
			WeatherStore.results.tideStationMarkerPopup.setHTML(text);
			WeatherStore.results.tideStationMarkerPopup.closeOnMove = true;
			tideStationMarker.setLngLat([$tidalExtremes.meta.station.lng, $tidalExtremes.meta.station.lat]);
			tideStationMarker.setPopup(WeatherStore.results.tideStationMarkerPopup);
			tideStationMarker.addTo(MapStore.helpers.getMap());
		}
	};
	$: {
		$tidalExtremes;
		updateTideStationMarker();
	}

	$: {
		$lastUpdated;
		WeatherStore.results.rangeRing.input.lng.set($lngLat.lng);
		WeatherStore.results.rangeRing.input.lat.set($lngLat.lat);
		WeatherStore.results.rangeRing.setRadius(0);

		const map = MapStore.helpers.getMap();
		if (map) {
			let linesSource = map.getSource(MapDataSource.ENVIRONMENT_LINES);
			let labelsSource = map.getSource(MapDataSource.ENVIRONMENT_LABELS);
			if ($state === LoadState.LOADED) {
				WeatherStore.results.rangeRing.setRadius($current.visibility.value, "Horizontal Visibility: \n");
				const arc = get(WeatherStore.results.rangeRing.result.arc);
				const lbl = get(WeatherStore.results.rangeRing.result.label);
				if (linesSource) {
					linesSource.setData( GeoHelper.emptyGeoJson([arc]) );
				}
				if (labelsSource) {
					labelsSource.setData( GeoHelper.emptyGeoJson([lbl]) );
				}
			}
			else {
				if (linesSource) {
					linesSource.setData( GeoHelper.emptyGeoJson() );
				}
				if (labelsSource) {
					labelsSource.setData( GeoHelper.emptyGeoJson() );
				}
			}
		}

	}

	let onSubmit = () => {
		WeatherStore.actions.submit();
	};

	// let onReset = () => {
		// WeatherStore.actions.resetAll();
	// }

	let onClear = () => {
		WeatherStore.actions.clear();
	};

	onMount(() => {
		if (GeoHelper.isValidLngLat($lngLatReadable)) {
			lngLatMarker.setLngLat([$lngLat.lng, $lngLat.lat]);
			lngLatMarker.addTo(MapStore.helpers.getMap());
		}
		InfoCardStore.actions.close();
		MapLayerManager.updateVisibleLayers();
		LoadingStore.add("weather", state);

		return () => {
			LoadingStore.remove("weather");
			lngLatMarker.remove();
			tideStationMarker.remove();
		};
	});


	let timeSliderData = WeatherStore.timeSliderData;
	$: {
		$toDatetime;
		$fromDatetime;
		updateTimeSliderMinMax();
	}
	let updateTimeSliderMinMax = () => {
		let minDate = moment($fromDatetime).startOf("day");
		let maxDate = moment($toDatetime).add(1, "day");
		timeSliderData.min.set(minDate);
		timeSliderData.max.set(maxDate);
		timeSliderData.step.set(3600);
		timeSliderData.value.set(get(timeSliderData.max));
	};

	// SG API only returns 10 days of Weather in the response. Limit the inputs.
	let timeEndDate = $toDatetime;
	$: {
		$fromDatetime;
		let timeEnd = moment($fromDatetime).startOf("day").add(8, "day");
		if (moment($toDatetime) > timeEnd) {
			$toDatetime = timeEnd.toDate();
		}
		timeEndDate = timeEnd.toDate();
	}

	// Update "current" weather item when the timeslider changes.
	WeatherStore.timeSliderData.value.subscribe((value) => {
		WeatherStore.actions.setCurrentBasedOnTime(value);
	});



	let _GSA = WeatherStore.helpers.getSourceAcronym;
	let _FORMAT = WeatherStore.helpers.formatValue;
	let _FORMAT_TIDE = WeatherStore.helpers.formatTideValue;

	let getter = (instance, data, index) => {
		return data.hours[index][instance.key].sg;
	}
	let getterPCT = (instance, data, index) => {
		return (!!data.hours[index][instance.key])?data.hours[index][instance.key].sg*100:0;
	}
	let degreesOverrides = {stepSize: 1, suggestedMin: 0, suggestedMax:360};
	let percentageOverrides = {stepSize: 1, suggestedMin: 0, suggestedMax:100};
	let percentageNormalOverrides = {stepSize: 0.01, suggestedMin: 0, suggestedMax:1};
	let otherOverrides = {stepSize: 0.1, suggestedMin: 0};
	let weatherGraphShowing = false;

	let weatherGraphProperties = [];
	let weatherGraphRegularProperties = [];
	weatherGraphRegularProperties.push(new GraphProperty("Wind Speed", "windSpeed", GraphPropertyUnitType.METERS_PER_SECOND, getter));
	weatherGraphRegularProperties.push(new GraphProperty("Wind Direction", "windDirection", GraphPropertyUnitType.DEGREES, getter, degreesOverrides));
	weatherGraphRegularProperties.push(new GraphProperty("Air Temperature", "airTemperature", GraphPropertyUnitType.DEGREES_CELCIUS, getter));
	weatherGraphRegularProperties.push(new GraphProperty("Air Pressure", "pressure", GraphPropertyUnitType.HECTOPASCAL, getter));
	weatherGraphRegularProperties.push(new GraphProperty("Cloud Cover", "cloudCover", GraphPropertyUnitType.PERCENTAGE, getter, percentageOverrides));
	weatherGraphRegularProperties.push(new GraphProperty("Ice Cover", "iceCover", GraphPropertyUnitType.PERCENTAGE_NORMALISED, getterPCT, percentageOverrides));
	weatherGraphRegularProperties.push(new GraphProperty("Precipitation", "precipitation", GraphPropertyUnitType.KILOGRAMS_PER_METER_SQUARED, getter, otherOverrides));
	weatherGraphRegularProperties.push(new GraphProperty("Horizonal Visibility", "visibility", GraphPropertyUnitType.KILOMETERS, getter));
	
	let weatherAltitudeGraphProperties = [];
	let windSpeed1000Graph = new GraphProperty("Wind Speed (1000 hpa)", "windSpeed1000hpa", GraphPropertyUnitType.METERS_PER_SECOND, getter);
	let windSpeed800Graph = new GraphProperty("Wind Speed (800 hpa)", "windSpeed800hpa", GraphPropertyUnitType.METERS_PER_SECOND, getter);
	let windSpeed500Graph = new GraphProperty("Wind Speed (500 hpa)", "windSpeed500hpa", GraphPropertyUnitType.METERS_PER_SECOND, getter);
	let windSpeed200Graph = new GraphProperty("Wind Speed (200 hpa)", "windSpeed200hpa", GraphPropertyUnitType.METERS_PER_SECOND, getter);
	let windDirection1000Graph = new GraphProperty("Wind Direction (1000 hpa)", "windDirection1000hpa", GraphPropertyUnitType.DEGREES, getter, degreesOverrides);
	let windDirection800Graph = new GraphProperty("Wind Direction (800 hpa)", "windDirection800hpa", GraphPropertyUnitType.DEGREES, getter, degreesOverrides);
	let windDirection500Graph = new GraphProperty("Wind Direction (500 hpa)", "windDirection500hpa", GraphPropertyUnitType.DEGREES, getter, degreesOverrides);
	let windDirection200Graph = new GraphProperty("Wind Direction (200 hpa)", "windDirection200hpa", GraphPropertyUnitType.DEGREES, getter, degreesOverrides);
	let airTemperature1000Graph = new GraphProperty("Air Temperature (1000 hpa)", "airTemperature1000hpa", GraphPropertyUnitType.DEGREES_CELCIUS, getter);
	let airTemperature800Graph = new GraphProperty("Air Temperature (800 hpa)", "airTemperature800hpa", GraphPropertyUnitType.DEGREES_CELCIUS, getter);
	let airTemperature500Graph = new GraphProperty("Air Temperature (500 hpa)", "airTemperature500hpa", GraphPropertyUnitType.DEGREES_CELCIUS, getter);
	let airTemperature200Graph = new GraphProperty("Air Temperature (200 hpa)", "airTemperature200hpa", GraphPropertyUnitType.DEGREES_CELCIUS, getter);

	$: {
		$vessel;

		let useProperties = [
			...weatherGraphRegularProperties
		];
		if ($vessel !== null && $vessel.type === ModelType.AIRCRAFT && User.hasFeature(Feature.ENVIRONMENT.ALTITUDINAL_DATA.VIEW)) {
			if (showAltitudes.indexOf(1000) >= 0) {
				useProperties.push(windSpeed1000Graph);
				useProperties.push(windDirection1000Graph)
				useProperties.push(airTemperature1000Graph);
			}
			if (showAltitudes.indexOf(800) >= 0) {
				useProperties.push(windSpeed800Graph);
				useProperties.push(windDirection800Graph)
				useProperties.push(airTemperature800Graph);
			}
			if (showAltitudes.indexOf(500) >= 0) {
				useProperties.push(windSpeed500Graph);
				useProperties.push(windDirection500Graph)
				useProperties.push(airTemperature500Graph);
			}
			if (showAltitudes.indexOf(200) >= 0) {
				useProperties.push(windSpeed200Graph);
				useProperties.push(windDirection200Graph)
				useProperties.push(airTemperature200Graph);
			}
		}

		weatherGraphProperties = useProperties;
	}
	
	// We can do "multiple" properties with an array.
	// graphProperties.push([
	// 	new GraphProperty("Wind Direction", "windDirection", GraphPropertyUnitType.DEGREES, getter),
	// 	new GraphProperty("Horizonal Visibility", "visibility", GraphPropertyUnitType.KILOMETERS, getter)
	// ]);
	let marineGraphShowing = false;
	let marineGraphProperties = [];
	marineGraphProperties.push(new GraphProperty("Wave Height", "waveHeight", GraphPropertyUnitType.METERS, getter));
	marineGraphProperties.push(new GraphProperty("Wave Direction", "waveDirection", GraphPropertyUnitType.DEGREES, getter, degreesOverrides));
	marineGraphProperties.push(new GraphProperty("Wave Period", "wavePeriod", GraphPropertyUnitType.SECONDS, getter));
	marineGraphProperties.push(new GraphProperty("Current Speed", "currentSpeed", GraphPropertyUnitType.METERS_PER_SECOND, getter));
	marineGraphProperties.push(new GraphProperty("Current Direction", "currentDirection", GraphPropertyUnitType.DEGREES, getter, degreesOverrides));

	let showAllDataValues = writable(false);
	$: {
		// TOOD: consider enabling graphs for different data source properties..
		// e.g. windSpeed (ICON), windSpeed (METO), etc.
	}

	let isCurrentPointOverLand = () => {
		return $current.waveHeight.value === "N/A" &&
				$current.waveDirection.value === "N/A" &&
				$current.currentSpeed.value === "N/A" &&
				$current.currentDirection.value === "N/A";
	};

	let onDownloadCSVUrl = () => {

		let weather = get(WeatherStore.results.weather);
		let astronomy = get(WeatherStore.results.astronomy).data;
		let tidalExtremes = get(WeatherStore.results.tidalExtremes).data;

		const nl = "\n";
		let csv = `"timestamp", "windSpeed_metersPerSecond", "windDirection_degrees", "airTemperature_degreesCelcius", "airPressure_hectopascal", "cloudCover_percentage", "iceCover_percentageNormalised", "precipitation_kilogramsPerMeterSquared", "horizontalVisibility_kilometers", "waveHeight_meters", "waveDirection_degrees", "wavePeriod_seconds", "currentSpeed_metersPerSecond", "currentDirection_degrees", "tidalExtremeHeight_meters", "tideStationName", "tideStationLng", "tideStationLat", "elevationBathymetry_meters", "sunrise_timestamp", "sunset_timestamp" ${nl}`;

		// const nowTime = moment.utc(time);
		for (let i = 0; i < weather.hours.length; i++) {
			let point = weather.hours[i];
			let currentExtreme = WeatherStore.helpers.getMiscForTime(point.time, tidalExtremes);
			let currentAstronomy = WeatherStore.helpers.getMiscForTime(point.time, astronomy);
			csv += `"${point.time}", "${point.windSpeed.sg}", "${point.windDirection.sg}", "${point.airTemperature.sg}", "${point.pressure.sg}", "${point.cloudCover.sg}", "${((!!point.iceCover)?point.iceCover.sg:0)}", "${point.precipitation.sg}", "${point.visibility.sg}", "${point.waveHeight.sg}", "${point.waveDirection.sg}", "${point.wavePeriod.sg}", "${point.currentSpeed.sg}", "${point.currentDirection.sg}", "${currentExtreme.height}", "${get(tidalExtremes).meta.station.name}", "${get(tidalExtremes).meta.station.lng}", "${get(tidalExtremes).meta.station.lat}", "${$elevation.data.elevation}", "${currentAstronomy.sunrise}", "${currentAstronomy.sunset}"${nl}`;
		}
		// let filename = "environment_19.1992-33.7919_2020-08-25";
		console.log("csv", csv);
		return DownloadHelper.asLink(csv, DataFormat.CSV);
	};
	let downloadFileName = writable("");
	$: {
		const parsedLngLat = GeoHelper.parseStringLngLat($lngLatReadable);
		let from = moment($fromDatetime).format("YYYY/MM/DD");
		let to = moment($toDatetime).format("YYYY/MM/DD");

		$downloadFileName = "geonius_environment_" + parsedLngLat[0] + "-" + parsedLngLat[1] + "_" + from + "_" + to + ".csv";
	}

	let user = AuthStore.session.user;
	let datePickerDialect = DateDialect.DMY;
	let datePickerStrFormat = "#{F} #{j}, #{Y}"; //"#{d}/#{m}/#{Y}"
	$: {
		datePickerDialect = $user.dateDialect;
		console.log("datePickerDialect", datePickerDialect);
		// if (datePickerDialect === DateDialect.MDY) {
		// 	datePickerStrFormat = "#{m}/#{d}/#{Y}"
		// }
	}

</script>

<div id='weather-components'>
	<div id='input-form'>

		<MenuItem title={"Query Environment"} materialIcon={"query_builder"}>

			{#if $vessel !== null}
				<h2>{StringHelper.ucfirst($vessel.type)}:</h2>
				<p>
					{$vessel.name}
					{#if $vessel.type === ModelType.VESSEL}
						{#if !!$vessel.imo}
							(IMO: {$vessel.imo})
						{:else}
							(MMSI: {$vessel.mmsi})
						{/if}
					{:else if $vessel.type === ModelType.AIRCRAFT}
						{#if !!$vessel.icaoAddress}
							(ICAO: {$vessel.icaoAddress})
						{/if}
					{/if}
				</p>

				<h2>Point (lng, lat):</h2>
				<p>{$vessel.coordinates}</p>

				{#if $vessel !== null && $vessel.type === ModelType.AIRCRAFT}
					<h2>Altitude:</h2>
					<p>{Vessel.formatAltitude($vessel.currentValidAltitude)} ({GeoHelper.feetToMbar($vessel.currentValidAltitude)} hPa)</p>
				{/if}

				<h2>Date:</h2>
				<p>{$vessel.currentTimestamp}</p>

				<h2>Range:</h2>
				<p>From: {$fromDatetime}<br/>
				   To: {$toDatetime}</p>
			{:else}

				<h2>Point (lng, lat):</h2>
				<TextfieldWithButton
					bind:value={$lngLatReadable}
					disabled={$state === LoadState.LOADING || $state === LoadState.LOADED}
					buttonIcon="colorize"
					on:change={()=>{
						updatePoint($lngLatReadable);
					}}
					on:keyup={(e) => {
						updatePointEvent(e);
					}}
					on:buttonclick={(e) => {
						MapStore.helpers.startSingleLngLatPick((resultText)=>{
							updatePoint(resultText);
						});
					}}
					/>

				<Datepicker
					start={useYearsAgo}
					end={$toDatetime}
					format={datePickerStrFormat}
					bind:selected={$fromDatetime}
					bind:formattedSelected={fromFormattedSelected}>
					<Button color="secondary" variant="unelevated" style="width:100%;margin-top:10px;" disabled={$state !== LoadState.INIT}><Label>From: {fromFormattedSelected}</Label></Button>
				</Datepicker>

				<Datepicker
					start={$fromDatetime}
					end={timeEndDate}
					format={datePickerStrFormat}
					bind:selected={$toDatetime}
					bind:formattedSelected={toFormattedSelected}>
					<Button color="secondary" variant="unelevated" style="width:100%;margin-top:5px;" disabled={$state !== LoadState.INIT}><Label>To: {toFormattedSelected}</Label></Button>
				</Datepicker>

			{/if}

			<hr/>

			<Button on:click={onSubmit} color="secondary" variant="unelevated" id="vessels-nearby-submit" style="width:100%;margin-top:10px;" disabled={$state === LoadState.LOADING}><Label>Submit</Label></Button>
			<Button on:click={onClear} title="Clear" class='bg-info' variant="unelevated" style="width:100%;margin-top:5px;" disabled={$state === LoadState.LOADING}><Label>Reset</Label></Button>

			{#if $error.length > 0}
				<div class='error bg-error'>
					{$error}
				</div>
			{/if}
		</MenuItem>
	</div>

	{#if $state === LoadState.LOADED}
		<!-- public | -->
		<MenuItem title={"Weather"} materialIcon={"wb_sunny"}>
			<table>
				<WeatherTableRow current={current} name="Wind Speed" key={"windSpeed"} unitSuffix={" mtrs/sec"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Wind Direction" key={"windDirection"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Air Temperature" key={"airTemperature"} unitSuffix={"°C"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Air Pressure" key={"pressure"} unitSuffix={" hPa"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Cloud Cover" key={"cloudCover"} unitSuffix={"%"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Ice Cover" key={"iceCover"} transformValue={(value)=>{ return value*100; }} unitSuffix={"%"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Precipitation" key={"precipitation"} unitSuffix={" kg/m²"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Horizontal Visibility" key={"visibility"} unitSuffix={" km"} bind:showAll={$showAllDataValues}/>
			</table>
			{#if User.hasFeature(Feature.ENVIRONMENT.ALTITUDINAL_DATA.VIEW)}
				<MenuItemTitle title="At Altitude" materialIcon={"flight"}/>
				<table>
					<!-- {#if $vessel !== null && $vessel.type === ModelType.AIRCRAFT}
						<tr>
							<td colspan='3'>
								<span>Altitude:</span> {Vessel.formatAltitude($vessel.currentValidAltitude)}<br/>
								<span>hPa:</span> {GeoHelper.feetToMbar($vessel.currentValidAltitude)}<br/>
							</td>
						</tr>
					{/if} -->

					{#if showAltitudes.indexOf(1000) >= 0}
						<WeatherTableRow current={current} name="Wind Spd (1000 hPa)" key={"windSpeed1000hpa"} unitSuffix={" km"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(800) >= 0}
						<WeatherTableRow current={current} name="Wind Spd (800 hPa)"  key={"windSpeed800hpa"} unitSuffix={" km"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(500) >= 0}
						<WeatherTableRow current={current} name="Wind Spd (500 hPa)"  key={"windSpeed500hpa"} unitSuffix={" km"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(200) >= 0}
						<WeatherTableRow current={current} name="Wind Spd (200 hPa)"  key={"windSpeed200hpa"} unitSuffix={" km"} bind:showAll={$showAllDataValues}/>
					{/if}

					{#if showAltitudes.indexOf(1000) >= 0}
						<WeatherTableRow current={current} name="Wind Dir (1000 hPa)" key={"windDirection1000hpa"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(800) >= 0}
						<WeatherTableRow current={current} name="Wind Dir (800 hPa)"  key={"windDirection800hpa"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(500) >= 0}
						<WeatherTableRow current={current} name="Wind Dir (500 hPa)"  key={"windDirection500hpa"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(200) >= 0}
						<WeatherTableRow current={current} name="Wind Dir (200 hPa)"  key={"windDirection200hpa"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
					{/if}

					{#if showAltitudes.indexOf(1000) >= 0}
						<WeatherTableRow current={current} name="Air Temp (1000 hPa)" key={"airTemperature1000hpa"} unitSuffix={"°C"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(800) >= 0}
						<WeatherTableRow current={current} name="Air Temp (800 hPa)"  key={"airTemperature800hpa"} unitSuffix={"°C"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(500) >= 0}
						<WeatherTableRow current={current} name="Air Temp (500 hPa)"  key={"airTemperature500hpa"} unitSuffix={"°C"} bind:showAll={$showAllDataValues}/>
					{/if}
					{#if showAltitudes.indexOf(200) >= 0}
						<WeatherTableRow current={current} name="Air Temp (200 hPa)"  key={"airTemperature200hpa"} unitSuffix={"°C"} bind:showAll={$showAllDataValues}/>
					{/if}
				</table>
			{/if}
			<Button on:click={() => { weatherGraphShowing = !weatherGraphShowing; }} color="secondary" variant="unelevated" style="width:100%;margin-top:10px;">
				<Label>{#if weatherGraphShowing}Hide Time Series{:else}Show Time Series{/if}</Label>
			</Button>
			{#if weatherGraphShowing}
				<EnvironmentGraph
					data={WeatherStore.results.weather}
					timeSlider={WeatherStore.timeSliderData}
					propertyIndex={ 0 }
					propertyOptions={weatherGraphProperties}
					height={200} />
			{/if}
		</MenuItem>
		<MenuItem title={"Marine"} materialIcon={"waves"}>
			<table>
				<WeatherTableRow current={current} name="Wave Height" key={"waveHeight"} unitSuffix={" mtrs"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Wave Direction" key={"waveDirection"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Wave Period" key={"wavePeriod"} unitSuffix={" secs"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Current Speed" key={"currentSpeed"} unitSuffix={" mtrs/sec"} bind:showAll={$showAllDataValues}/>
				<WeatherTableRow current={current} name="Current Direction" key={"currentDirection"} unitSuffix={"°"} showArrow={true} bind:showAll={$showAllDataValues}/>
			</table>
			{#if isCurrentPointOverLand()}
			  	 <div class='warning bg-warning' style="margin-bottom:10px;">
			  	 	Point (lng,lat) was very likely over land.
			  	 </div>
			{/if}

			<table>
				<tr>
					<td style="width:37%;">Nearest Tide Station:</td>
					<td colspan='2'>{$tidalExtremes.meta.station.name.toUpperCase()} (<a href="/" on:click={(e)=>{
						e.preventDefault();
						MapStore.helpers.zoomToLine(
							[$tidalExtremes.meta.station.lng, $tidalExtremes.meta.station.lat],
							[$lngLat.lng, $lngLat.lat]
						);
					}}>{$tidalExtremes.meta.station.lng}, {$tidalExtremes.meta.station.lat}</a>)</td>
				</tr>
				<tr>
					<td style="width:37%;vertical-align: top;">Tidal Extreme:</td>
					<td colspan='2'>
						{_FORMAT_TIDE($tidalExtremeCurrent.height.value)}<br/>
						({$tidalExtremeCurrent.time.format("MMM Do, hh:mma [(UTC)]")})
					</td>
				</tr>
			</table>
			{#if !isCurrentPointOverLand()}
				<Button on:click={() => { marineGraphShowing = !marineGraphShowing; }} color="secondary" variant="unelevated" style="width:100%;margin-top:10px;">
					<Label>{#if marineGraphShowing}Hide Time Series{:else}Show Time Series{/if}</Label>
				</Button>
				{#if marineGraphShowing}
					<EnvironmentGraph
						data={WeatherStore.results.weather}
						timeSlider={WeatherStore.timeSliderData}
						propertyIndex={ 0 }
						propertyOptions={marineGraphProperties}
						height={200} />
				{/if}
			{/if}

		</MenuItem>

		<TimeSlider data={WeatherStore.timeSliderData} hasNowButton={true}/>

		<MenuItem title={"Miscellaneous"}>
			<table>
				<tr>
					<td>Sunrise:</td>
					<td>{moment($astronomyCurrent.sunrise.value).format("hh:mm:ss a [(UTC)]")}</td>
				</tr>
				<tr>
					<td>Sunset:</td>
					<td>{moment($astronomyCurrent.sunset.value).format("hh:mm:ss a [(UTC)]")}</td>
				</tr>
				<tr>
					<td>
						{#if $elevation.data.elevation > 0}
							Elevation:
						{:else}
							Bathymetry:
						{/if}
					</td>
					<td>{_FORMAT(roundFloat($elevation.data.elevation, 2), " " + $elevation.meta.elevation.unit)}</td>
					<td class='data-source' title={$elevation.meta.elevation.source}>{$elevation.meta.elevation.source.substr(0, $elevation.meta.elevation.source.indexOf(" "))}</td>
				</tr>
			</table>
		</MenuItem>

		<!-- <MenuItem class='last-updated'>
			<b>Weather Updated At:</b><br/>
			<small>{$current.time.format(datetimeFormat)}</small>
		</MenuItem> -->
		<!-- <MenuItem title={"Elevation"} materialIcon={"terrain"}>
			<table>
				<tr>
					<td>Bathymetry:</td>
					<td></td>
				</tr>
			</table>
		</MenuItem> -->

		<MenuItem title={"Misc"}>
			<h2 class='mt-0'>Options</h2>
			<LayerListSwitch label={"View All Data Values"} bind:checked={$showAllDataValues}/>
			<!-- (($showAllDataValues)?"Show":"Hide")+" -->

			<h2>Export</h2>
			<DownloadButton filename={$downloadFileName} text="Download CSV" content={onDownloadCSVUrl} />
		</MenuItem>


	{/if}

</div>
